import React from "react";

// Components
import Loader from "../../../utils/Loader";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

export const SectorsFieldset = ({
	data, errors, inProcess, sectors, sectorsLoading, sectorsError, handleCheckboxClickArray
}) => {
	return (
		<div className="fieldset">
			<div className="title-label">Sectors</div>

			<div className="fieldset-indent">
				<div className="floated-field-container">
					{sectorsError ? (
						<ErrorWrap>{sectorsError}</ErrorWrap>
					) : sectorsLoading ? (
						<Loader />
					) : (
						<div className="form-field pb1">
							{!!errors.sectors && (
								<ErrorWrap animate={1}>{errors.sectors}</ErrorWrap>
							)}

							{!sectors.length ? (
								<ErrorWrap>
									There are no sector options available at the moment.
								</ErrorWrap>
							) : (
								<React.Fragment>
									{Object.keys(sectors).map(key => {
										const { id } = sectors[key];

										// See if this sector is checked off
										const selectedObject = data.sectors.find(sector => {
											return sector.sector_id === id;
										});

										return (
											<div key={key} className="form-field">
												<div
													className={`custom-label checkbox-label${
														inProcess ? " disabled-label" : ""
													}`}
												>
													<input
														type="checkbox"
														id={`sectors_${key}`}
														value={id}
														checked={!!selectedObject}
														disabled={inProcess}
														onChange={e =>
															handleCheckboxClickArray(
																{ sector_id: sectors[key].id },
																"sectors"
															)
														}
													/>
													<label htmlFor={`sectors_${key}`}>
														{sectors[key].title + " (" + sectors[key].description + ")"}
													</label>
												</div>
											</div>
										);
									})}
								</React.Fragment>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default SectorsFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/organizations/form-components/SectorsFieldset.js